.legend {
  display: grid;
  gap: var(--dimension-space-2);
  margin: 0;
  padding: var(--dimension-space-3);
  list-style: none;
  background: var(--color-surface-raised);
  border: var(--dimension-line-hairline) solid var(--color-border-hairline);
  color: var(--color-text-primary);
}
.legend li {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-2);
}
.card {
  display: grid;
  gap: var(--dimension-space-2);
  padding: var(--dimension-space-4);
  background: var(--color-surface-base);
  border-radius: 22px;
  box-shadow: 0 4px 12px color-mix(in srgb, var(--color-text-primary) 12%, transparent);
  color: var(--color-text-primary);
}
.head {
  display: flex;
  justify-content: space-between;
  gap: var(--dimension-space-2);
  color: var(--color-text-secondary);
  text-transform: uppercase;
}
.body {
  display: flex;
  gap: var(--dimension-space-3);
  align-items: flex-start;
}
.photo {
  flex: none;
  width: 64px;
  height: 64px;
  object-fit: cover;
  background: var(--color-surface-sunken);
}
.text {
  display: grid;
  gap: 4px;
  min-width: 0;
}
.muted {
  color: var(--color-text-secondary);
}
.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
